// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__wRdJn {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  height: fit-content;
  padding: 0.5em 0;
}
.styles_container__wRdJn input {
  background-color: transparent;
  width: 100%;
  border: none;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  padding: 0 0.5em;
  background-color: transparent;
  width: 100%;
  border: none;
}
.styles_container__wRdJn input:focus-visible {
  outline: 0;
}
.styles_container__wRdJn input::placeholder {
  color: #bababa;
}

.styles_inputTitle__LGhZ8 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  margin-bottom: 8px;
}

.styles_inputError__\\+aBJM {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_inputErrorProfile__hsQsT {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #D8000D;
  margin-bottom: 8px;
}

.styles_inputStyle__Py1XR {
  width: 353px;
  height: 44px;
}

.styles_wrapper__h3nV7 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 100%;
  height: auto;
  min-height: 44px;
}

.styles_prefix0__aX0e3 {
  width: 90%;
  height: auto;
  flex-wrap: wrap !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}

.styles_prefix__EpKhH,
.styles_affix__sfu7n {
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_yellowBorder__Sec6R {
  border: 1px solid #FF9315;
}

.styles_redBorder__Y7c2p {
  border: 1px solid #D8000D;
}

.styles_lds_ring__F0m8h {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
}

.styles_lds_ring__F0m8h div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__F0m8h 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ring__F0m8h div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__F0m8h div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__F0m8h div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__F0m8h {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppFormBox/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EAGA,gBAAA;EAEA,6BAAA;EACA,WAAA;EACA,YAAA;AAHJ;AAOE;EACE,UAAA;AALJ;AAQE;EACE,cAAA;AANJ;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAPF;;AAUA;EACE,YAAA;EACA,YAAA;AAPF;;AAUA;EAEE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAcA;EAEE,UAAA;EACA,YAAA;EAMA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;AAjBF;;AAsBA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAnBF;;AAuBA;EAEE,yBAAA;AArBF;;AAwBA;EAEE,yBAAA;AAtBF;;AA2BA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AAxBF;;AA2BA;EACE,uBAAA;AAxBF;;AA2BA;EACE,sBAAA;AAxBF;;AA2BA;EACE,uBAAA;AAxBF;;AA2BA;EACE;IACE,uBAAA;EAxBF;EA2BA;IACE,yBAAA;EAzBF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  height: fit-content;\n  padding: 0.5em 0;\n\n  input {\n    background-color: transparent;\n    width: 100%;\n    border: none;\n    // background-color: #fafafa;\n    border-radius: 8px;\n    border: 1px solid #eeeeee;\n    // width: 353px;\n    // height: 44px;\n    padding: 0 0.5em;\n\n    background-color: transparent;\n    width: 100%;\n    border: none;\n\n  }\n\n  input:focus-visible {\n    outline: 0;\n  }\n\n  input::placeholder {\n    color: #bababa;\n  }\n}\n\n.inputTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  margin-bottom: 8px;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.inputErrorProfile {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #D8000D;\n  margin-bottom: 8px;\n}\n\n.inputStyle {\n  width: 353px;\n  height: 44px;\n}\n\n.wrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px;\n  // background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 100%;\n  height: auto;\n  min-height: 44px;\n\n\n}\n\n.prefix0 {\n  // direction: ltr;\n  width: 90%;\n  height: auto;\n  // height: 45px;\n  // max-width: 90%;\n  // overflow-y: scroll;\n  // height: 40px;\n  // overflow-y: scroll;\n  flex-wrap: wrap !important;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  // -moz-appearance: textfield-multiline;\n  // -webkit-appearance: textarea;\n}\n\n.prefix,\n.affix {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n}\n\n.yellowBorder {\n\n  border: 1px solid #FF9315;\n}\n\n.redBorder {\n\n  border: 1px solid #D8000D;\n}\n\n//------------------------loader style\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__wRdJn`,
	"inputTitle": `styles_inputTitle__LGhZ8`,
	"inputError": `styles_inputError__+aBJM`,
	"inputErrorProfile": `styles_inputErrorProfile__hsQsT`,
	"inputStyle": `styles_inputStyle__Py1XR`,
	"wrapper": `styles_wrapper__h3nV7`,
	"prefix0": `styles_prefix0__aX0e3`,
	"prefix": `styles_prefix__EpKhH`,
	"affix": `styles_affix__sfu7n`,
	"yellowBorder": `styles_yellowBorder__Sec6R`,
	"redBorder": `styles_redBorder__Y7c2p`,
	"lds_ring": `styles_lds_ring__F0m8h`
};
export default ___CSS_LOADER_EXPORT___;
